export default __webpack_public_path__ + "static/media/aub.8caa58a5.jpg";